import * as React from 'react'
import { Typography,Button, Table, TableBody, TableHead, TableRow, TableCell, Select, MenuItem, TableContainer, Paper, withStyles, Theme, createStyles, CircularProgress, Box } from '@material-ui/core'
import AutoCheckInput from '../../components/AutoCheckInput';
import axios from 'axios'
import { listOrder, finishOrder } from '../../utils/api'
import { useFeedback } from '../../components/Feedback'
import useRefresh from '../../hooks/useRefresh'
import moment from 'moment'

type Order = {
    id: number,
    amount: number,
    create_time: number,
    finish_time: number,
    mobile: string,
    name: string,
    order_no: string,
    type: number,
    status: string,
    editing: boolean,
    title: string,
    use_balance: number,
    national_code:number
}
const defaultOrders: Order[] = []

const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: theme.palette.secondary.light,
            color: theme.palette.common.white,
        },
        body: {
            fontSize: 14,
        },
    }),
)(TableCell);

const Orders = () => {
    const [orders, setOrders] = React.useState(defaultOrders)
    const { showToast } = useFeedback()
    const [mobile, setMobile] = React.useState('')
    React.useEffect(() => {
        loadOrders()
    }, [])

    const loadOrders = () => {
        listOrder().then(res => {
            setOrders(res.data)
        })
    }

    useRefresh(() => {
        loadOrders()
    })

    const handleStatusChange = (order_no: string) => (event: React.ChangeEvent<{ value: unknown }>) => {
        orders.map(o => {
            if (o.order_no === order_no) {
                o.editing = true
                o.status = event.target.value as string
            }
            return o
        })
        setOrders([...orders])
        finishOrder(order_no).then(res => {
            loadOrders()
        }).catch(err => {
            showToast('修改失败')
            loadOrders()
        })
    }
    const handleMobileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setMobile(event.target.value)
    } 
    const handleSearchCustom = () => {
        axios.post('/api/admin/order/search', { mobile }).then(res => {
            if (res.data.length == 0) {
                showToast(mobile+'所属订单不存在')
            } else { 
                setOrders(res.data)
            }
           
        })
        

    }
    const addButtonDisable = () => {
        return /^1[3456789]\d{9}$/.test(mobile)
    }
 
    return <React.Fragment>
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box display="flex" alignItems="center">
                <Typography variant="inherit">搜索订单</Typography>
                <AutoCheckInput notNull mobile onChange={handleMobileChange} style={{ marginLeft: '10px' }} value={mobile} label="输入手机号" placeholder="输入手机号" />
                <Button onClick={handleSearchCustom} disabled={!addButtonDisable()} style={{ marginLeft: '10px' }} variant="contained" color="secondary">搜索</Button>
            </Box>
            <Box>
                <Button style={{ backgroundColor: addButtonDisable() ? '#69a9c7' : '' }} onClick={(e) => {
                    loadOrders()
                    setMobile('')
                    addButtonDisable()
                }} >所有订单</Button>		
            </Box>
        </Box>
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <StyledTableCell align="center">姓名</StyledTableCell>
                        <StyledTableCell align="center">手机号</StyledTableCell>
                        <StyledTableCell align="center">订单类型</StyledTableCell>
                        <StyledTableCell align="center">现金</StyledTableCell>
                        <StyledTableCell align="center">虚拟币</StyledTableCell>
                        <StyledTableCell align="center">创建时间</StyledTableCell>
                        <StyledTableCell align="center">交易完成时间</StyledTableCell>
                        <StyledTableCell align="center">订单状态</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {orders.map(order => <TableRow key={order.order_no}>
                        <TableCell align="center">{order.name}</TableCell>
                        <TableCell align="center">+{order.national_code +' '+ order.mobile}</TableCell>
                        <TableCell align="center">{order.title}</TableCell>
                        <TableCell align="center">{((order.amount - order.use_balance) / 100) ? `${(order.amount - order.use_balance) / 100}元` : '-'}</TableCell>
                        <TableCell align="center">{(order.use_balance / 100) ? `${(order.use_balance / 100)}爱豆` : '-'}</TableCell>
                        <TableCell align="center">{moment(order.create_time).format('YYYY-MM-DD HH:mm')}</TableCell>
                        <TableCell align="center">{order.finish_time ? moment(order.finish_time).format('YYYY-MM-DD HH:mm') : '-'}</TableCell>
                        <TableCell align="center">
                            <Select disabled={order.status === 'finish' || order.editing} onChange={handleStatusChange(order.order_no)} value={order.status}>
                                <MenuItem value="create">未支付</MenuItem>
                                <MenuItem value="finish">已支付</MenuItem>
                            </Select>
                            {order.editing && <CircularProgress size={12} />}
                        </TableCell>
                    </TableRow>)}
                </TableBody>
            </Table>
        </TableContainer>
    </React.Fragment>
}

export default Orders